import { useState } from "react";
import { Send, Upload } from "lucide-react";

const JoinTeamSection = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState(""); // 🆕 Novo campo
  const [role, setRole] = useState("");
  const [reason, setReason] = useState("");
  const [cv, setCv] = useState<File | null>(null);
  const [honeypot, setHoneypot] = useState(""); // 🕳️ Honeypot state
  const [submitted, setSubmitted] = useState(false);
  const [isSending, setIsSending] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim() || !email.trim() || !role.trim() || !reason.trim()) return;
    
    // 🤖 Verificação extra no frontend (opcional, a segurança real está no PHP)
    if (honeypot) return; 

    setIsSending(true);
    const formData = new FormData();
    formData.append("name", name);
    formData.append("email", email);
    formData.append("role", role);
    formData.append("reason", reason);
    formData.append("website", honeypot); // 🕳️ Nome clássico para honeypot
    if (cv) formData.append("cv", cv);

    try {
      const res = await fetch("/api/send-application.php", { // ⚠️ Ajusta ao teu caminho
        method: "POST",
        body: formData,
      });

      const data = await res.json();
      if (data.success) {
        setSubmitted(true);
      } else {
        alert(data.message || "Ocorreu um erro. Tenta novamente.");
      }
    } catch {
      alert("Erro de rede. Verifica a tua conexão.");
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div className="container mx-auto px-4 sm:px-6 lg:px-12 relative z-10">
      <div className="max-w-2xl mx-auto">
        <div className="text-center mb-8 sm:mb-12">
          <span className="section-label">Recrutamento</span>
          <h2 className="section-heading">
            Queres pertencer à <br />
            nossa <span className="text-accent">equipa</span>?
          </h2>
        </div>

        {submitted ? (
          <div className="glass-card p-8 sm:p-12 text-center">
            <div className="text-4xl mb-4">🎉</div>
            <h3 className="font-serif text-2xl text-foreground mb-2">Obrigado!</h3>
            <p className="text-muted-foreground">
              Recebemos a tua candidatura. Enviámos uma confirmação para o teu email e entraremos em contacto brevemente.
            </p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="glass-card p-6 sm:p-8 md:p-12 space-y-5 sm:space-y-6">
            <div>
              <label className="text-sm text-muted-foreground mb-2 block">Eu sou</label>
              <input
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="O teu nome"
                className="glass-input w-full px-4 sm:px-5 py-3 sm:py-3.5 text-sm"
                required
              />
            </div>

            {/* 🆕 Campo de Email Obrigatório */}
            <div>
              <label className="text-sm text-muted-foreground mb-2 block">Email de contacto</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="nome@exemplo.com"
                className="glass-input w-full px-4 sm:px-5 py-3 sm:py-3.5 text-sm"
                required
              />
            </div>

            <div>
              <label className="text-sm text-muted-foreground mb-2 block">Candidato-me à função de</label>
              <input
                type="text"
                value={role}
                onChange={(e) => setRole(e.target.value)}
                placeholder="Ex: Designer, Programador, Gestor de Projeto"
                className="glass-input w-full px-4 sm:px-5 py-3 sm:py-3.5 text-sm"
                required
              />
            </div>

            <div>
              <label className="text-sm text-muted-foreground mb-2 block">E gostaria de trabalhar convosco porque</label>
              <textarea
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                placeholder="Conta-nos a tua motivação..."
                rows={4}
                className="glass-input w-full px-4 sm:px-5 py-3 sm:py-3.5 text-sm resize-none"
                required
              />
            </div>

            <div>
              <label className="text-sm text-muted-foreground mb-2 block">Curriculum Vitae</label>
              <label className="glass-input flex items-center gap-3 px-4 sm:px-5 py-3 sm:py-3.5 text-sm cursor-pointer">
                <Upload size={16} className="text-muted-foreground shrink-0" />
                <span className={cv ? "text-foreground" : "text-muted-foreground"}>
                  {cv ? cv.name : "Anexar CV (PDF, DOC)"}
                </span>
                <input
                  type="file"
                  accept=".pdf,.doc,.docx"
                  onChange={(e) => setCv(e.target.files?.[0] || null)}
                  className="hidden"
                />
              </label>
            </div>

            {/* 🕳️ Honeypot Invisível (Anti-Spam) */}
            <div
              style={{ position: "absolute", left: "-9999px", opacity: 0, height: 0, width: 0, overflow: "hidden" }}
              aria-hidden="true"
            >
              <input
                type="text"
                name="website"
                value={honeypot}
                onChange={(e) => setHoneypot(e.target.value)}
                tabIndex={-1}
                autoComplete="off"
              />
            </div>

            <button
              type="submit"
              disabled={isSending}
              className="glass-btn w-full py-3.5 sm:py-4 text-sm font-medium flex items-center justify-center gap-2 disabled:opacity-60 disabled:cursor-not-allowed"
            >
              {isSending ? (
                <span className="animate-pulse">A enviar...</span>
              ) : (
                <>Enviar candidatura <Send size={15} /></>
              )}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default JoinTeamSection;